import { render, staticRenderFns } from "./IndicatorCard.vue?vue&type=template&id=3a4d5528&scoped=true"
import script from "./IndicatorCard.vue?vue&type=script&lang=js"
export * from "./IndicatorCard.vue?vue&type=script&lang=js"
import style0 from "./IndicatorCard.vue?vue&type=style&index=0&id=3a4d5528&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4d5528",
  null
  
)

export default component.exports